export enum FormInputType {
    TEXT = "text",
    NUMBER = "number",
    PASSWORD = "password",
}
